import { logo } from './logoInBase64';

const noBorders = {
    hLineWidth: () => 0,
    vLineWidth: () => 0,
    hLineColor: () => 0,
    paddingLeft: () => 0,
    paddingRight: () => 0,
};

export const headerLayout = { ...noBorders, fillColor: () => '#002554' };
export const expensesTableLayout = { ...noBorders, fillColor: (row: number) => (row === 0 ? '#72ce9a' : '#DEE4E7') };
export const plainLayout = { ...noBorders, fillColor: () => '' };

export const marginTable = [10, 5, 10, 5];
export const marginSummary = [3, 3, 3, 3];

// pdfmake mutates the nodes it renders, so content nodes are created fresh for every document
export const spacer = () => ({ text: '', margin: [0, 10] });

export const header = () => ({
    layout: headerLayout,
    table: {
        widths: ['auto', '*', 'auto'],
        body: [
            [
                { image: logo, width: 150, height: 40, margin: [10, 0, 10, 0] },
                { text: 'Expense Report Details', style: 'headerTitle', alignment: 'left', margin: [20, 10, 0, 10] },
                {},
            ],
        ],
    },
});

export const reportStyles = {
    headerTitle: { fontSize: 18, bold: true, color: 'white' },
    tableTitle: { fontSize: 10, bold: true, color: 'white' },
    tableRow: { fontSize: 10, bold: false },
    summaryRowTitle: { fontSize: 10, bold: true },
};
